export default "__VITE_ASSET__Bmts_GD5__"